import React,{useRef,useEffect} from 'react'
import "./header.css"
import { Container ,Row } from 'react-bootstrap'
import {NavLink,useNavigate} from 'react-router-dom'

import logo from '../../assets/images/eco-logo.png'
import user_icon from '../../assets/images/user-icon.png'
import { Link } from 'react-router-dom'
import nav__links from './Nav-links'
import {motion} from 'framer-motion'
import { useSelector } from 'react-redux'
import useAuth from '../../custom-hooks/useAuth'
import { signOut } from 'firebase/auth'
import { auth } from '../../firebase.config'
import { toast } from 'react-toastify'


const Header = () => {

  // Redux selector
  const totalQuantity = useSelector(state=>state.cart.totalQuantity)

  // USEREF USER
  const profileActionRef = useRef(null)

  const headerRef = useRef(null)
  const menuRef = useRef(null)
  const stickyHeader = ()=>{
    window.addEventListener('scroll',()=>{
      if(document.body.scrollTop > 80 || document.documentElement.scrollTop > 80){
        headerRef.current.classList.add('sticky__header')
      }else{
        headerRef.current.classList.remove('sticky__header')
      }
    })
  }
  const menuToggle = ()=> menuRef.current.classList.toggle('active__menu')

  useEffect(()=>{
    stickyHeader()
    return ()=> window.removeEventListener("scroll",stickyHeader)
  })

  const navigate = useNavigate()
  const navigateToCart = ()=>{
    navigate('/cart')
  }
  // Auth User
  const {currentUser} = useAuth()
  
  // logout user
  const logout = ()=>{
    signOut(auth).then(()=>{
      toast.success('Logged Out')
      navigate('/home')
    }).catch((error)=>toast.error(error.message))
  }

  // Add & remove Class 
  const toggleProfileAction = ()=> profileActionRef.current.classList.toggle('show__profileActions')


  return (
    <header className='header' ref={headerRef}>
      <Container>
        <Row>
          {/* right */}
          <div className='nav__wrapper'>
            <div className='logo'>
              <img src={logo} alt="Logo" />
                <div>
                  <h1>ElQaNaS</h1>
                </div>
            </div>

            {/* left */}
            <div className='navigation' onClick={menuToggle} ref={menuRef}>
              <ul className="menu">
                {
                  nav__links.map((item,index)=>{
                    return <li key={index} className="nav__item">
                        <NavLink className={(navClass)=>navClass.isActive?"nav__active":""} to={item.path}>{item.display}</NavLink>
                      </li>
                  }
                  )
                }
              </ul>
            </div>

            {/* icon side */}
            <div className='nav__icons'>
              <span className="fav__icon">
                <i className="ri-heart-line"></i>
                <span className="badge">1</span>
              </span>
              <span className="cart__icon" onClick={navigateToCart}>
                <i className='ri-shopping-bag-line'></i>
                <span className="badge">{totalQuantity}</span>
              </span>
              <div className='profile'>
                <motion.img onClick={toggleProfileAction} whileTap={{scale:1.2}} src={currentUser ? currentUser.photoURL : user_icon} alt="user" />
                <div className='profile__actions' onClick={toggleProfileAction} ref={profileActionRef}>
                  {
                    currentUser ? <span onClick={logout}>Logout</span> : 
                    <div className='user__login d-flex justify-content-center flex-column'>
                      <div><Link to='/signup'>Signup</Link></div>
                      <div><Link to='/login'>Login</Link></div>
                      <div><Link to='/dashboard'>Dashboard</Link></div>
                    </div>
                  }
                </div>
              </div>

              {/* Menu */}
              <div className='mobile__menu'>
                <span onClick={menuToggle}>
                  <i className="ri-menu-fill"></i>
                </span>
              </div>
            </div>

          </div>
          
        </Row>
      </Container>
    </header>
  )
}

export default Header